import cn from '#/utils/classnames'
import Container from './container'

interface PreviewProps {
  preview: boolean
}

const Alert: React.FC<PreviewProps> = ({ preview }) => (
  <div
    className={cn('border-b', {
      'bg-accent-7 border-accent-7 text-white': preview,
      'bg-accent-1 border-accent-2': !preview,
      hide: !preview
    })}
  >
    <Container>
      <div className='py-2 text-center text-sm'>
        {preview ? (
          <>
            This is page is a preview.
            {' '}
            <a
              className='underline transition-colors duration-200 hover:text-cyan-500'
              href='/api/exit-preview'
            >
              Click here
            </a>
            {' '}
            to exit preview mode.
          </>
        ) : (
          <>Welcome to the new TopHap Blog! 🎉</>
        )}
      </div>
    </Container>
  </div>
)

export default Alert
